import { REPORT } from '../types'

export const setReportLoading = loading => ({
  type: loading ? REPORT.LOADING_START : REPORT.LOADING_END,
})
